/// Pluggable random-number source. The MVP uses Math.random; later
/// phases will swap in a seeded PCG32 so test runs are reproducible.

export type RandomSource = () => number

export const defaultRng: RandomSource = Math.random

export function randInRange(rng: RandomSource, min: number, max: number): number {
  return min + rng() * (max - min)
}

export function randIntInclusive(rng: RandomSource, min: number, max: number): number {
  const lo = Math.ceil(min)
  const hi = Math.floor(max)
  return lo + Math.floor(rng() * (hi - lo + 1))
}

export function pick<T>(rng: RandomSource, items: readonly T[]): T | undefined {
  if (items.length === 0) return undefined
  return items[Math.floor(rng() * items.length)]
}
